export default __webpack_public_path__ + "static/media/userDefault.4a000e6c.svg";